// Generated file - do not change manually!

/**
 * Defines the horizontal alignment of <code>ui5-popover</code>
 */
export enum PopoverHorizontalAlign {
  /**
   * Popover is centered
   */
  Center = 'Center',

  /**
   * Popover opens on the left side of the target
   */
  Left = 'Left',

  /**
   * Popover opens on the right side of the target
   */
  Right = 'Right',

  /**
   * Popover is stretched
   */
  Stretch = 'Stretch'
}
